/**
 * Run work after the next paint so modal dismiss / button feedback can render first.
 */
export function deferAfterPaint(fn: () => void): void {
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => {
      requestAnimationFrame(fn);
    });
    return;
  }
  setTimeout(fn, 0);
}

/** Resolve after two animation frames so a newly shown overlay can paint first. */
export function yieldForPaint(): Promise<void> {
  return new Promise((resolve) => {
    deferAfterPaint(resolve);
  });
}

/** Run low-priority work when the browser is idle (falls back to a short timeout). */
export function deferWhenIdle(fn: () => void, timeoutMs = 2000): void {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => fn(), { timeout: timeoutMs });
    return;
  }
  setTimeout(fn, 50);
}
